import { Button } from "@mui/material"
import type { DockviewApi, IWatermarkPanelProps } from "dockview"
import { useCallback, type JSX } from "react"

interface Props extends IWatermarkPanelProps {
  onReset(api: DockviewApi): void
}

export default function DefaultWatermark({ containerApi, onReset }: Props): JSX.Element {
  const handleReset = useCallback(() => {
    onReset(containerApi)
  }, [containerApi, onReset])

  return (
    <div style={{ height: "100%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Button color="primary" variant="contained" size="large" onClick={handleReset}>
        Reset Layout
      </Button>
    </div>
  )
}
